"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardModalHeader = exports.DeleteModal = exports.ConfirmModal = exports.ConfirmModalButtons = exports.AcknowledgeModal = exports.SimpleModal = exports.Modal = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
exports.Modal = (0, mobx_react_1.observer)(function (props) {
    var isEscapable = props.isEscapable, callback = props.callback;
    var handleOutsideClick = function (e) {
        e.stopPropagation();
        if (isEscapable === false)
            return;
        if (callback)
            callback(false);
    };
    (0, react_1.useEffect)(function () {
        if (!callback)
            return;
        var cancelModal = function () { return callback(false); };
        window.addEventListener("popstate", cancelModal);
        return function () { return window.removeEventListener("popstate", cancelModal); };
    }, [callback]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("modal-container", props.containerClassName), onClick: handleOutsideClick },
        react_1.default.createElement("div", { className: (0, classnames_1.default)("modal", "center", props.className), onClick: function (event) { return event.stopPropagation(); } },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("content", "center", props.contentClassName) }, props.children))));
});
exports.SimpleModal = (0, mobx_react_1.observer)(function (props) {
    var onClose = function () {
        if (props.callback) {
            return props.callback(false);
        }
    };
    return (react_1.default.createElement(exports.Modal, { callback: props.callback, isEscapable: props.isEscapable, className: "simple-modal", containerClassName: props.containerClassName, contentClassName: props.contentClassName },
        react_1.default.createElement("div", null,
            !!props.title && (react_1.default.createElement("div", { className: "simple-modal__header" },
                react_1.default.createElement("div", { className: "simple-modal__title" }, props.title),
                react_1.default.createElement("div", { className: "simple-modal__close icon icon-clear", onClick: onClose }))),
            props.children)));
});
var AcknowledgeModal = function (props) {
    return (react_1.default.createElement(exports.Modal, { callback: props.callback, isEscapable: props.isEscapable, containerClassName: props.containerClassName },
        react_1.default.createElement("div", { className: "acknowledge-modal" },
            props.children,
            react_1.default.createElement("div", { className: "actions" },
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Primary, width: "half", size: kaleidoscope_1.ButtonSize.Large, onClick: function () {
                        if (props.callback) {
                            return props.callback(true);
                        }
                    } }, props.buttonLabel)))));
};
exports.AcknowledgeModal = AcknowledgeModal;
var ConfirmModalButtons = function (props) {
    var callback = props.callback, cancelLabel = props.cancelLabel, confirmButtonState = props.confirmButtonState, confirmButtonDestructive = props.confirmButtonDestructive, confirming = props.confirming, confirmLabel = props.confirmLabel, disableConfirmButton = props.disableConfirmButton, disableCancelButton = props.disableCancelButton;
    return (react_1.default.createElement("div", { className: "actions two-actions center" },
        react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, width: "normal", size: kaleidoscope_1.ButtonSize.Large, onClick: function () {
                if (callback) {
                    return callback(false);
                }
            }, disabled: disableCancelButton }, cancelLabel || "Cancel"),
        react_1.default.createElement(kaleidoscope_1.Button, { isDestructive: confirmButtonDestructive, type: kaleidoscope_1.ButtonType.Primary, buttonState: confirmButtonState, width: "normal", size: kaleidoscope_1.ButtonSize.Large, onClick: confirming, disabled: disableConfirmButton }, confirmLabel || "Confirm")));
};
exports.ConfirmModalButtons = ConfirmModalButtons;
var ConfirmModal = (function (_super) {
    __extends(ConfirmModal, _super);
    function ConfirmModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disableCancelButton = false;
        _this.onAsyncConfirmClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.props.disableConfirmButton) {
                            return [2];
                        }
                        this.disableCancelButton = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, Promise.all([
                                this.maybeTriggerConfirming(),
                                new Promise(function (resolve) {
                                    setTimeout(resolve, 500);
                                }),
                            ])];
                    case 2:
                        _a.sent();
                        setTimeout(function () {
                            if (_this.props.callback) {
                                return _this.props.callback(true);
                            }
                        }, 200);
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.disableCancelButton = false;
                        throw new Error(error_1);
                    case 4: return [2];
                }
            });
        }); };
        _this.onConfirmClick = function () {
            if (_this.props.callback && !_this.props.disableConfirmButton) {
                return _this.props.callback(true);
            }
        };
        _this.maybeTriggerConfirming = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.props.confirming) {
                    return [2, this.props.confirming()];
                }
                return [2];
            });
        }); };
        return _this;
    }
    ConfirmModal.prototype.render = function () {
        return (react_1.default.createElement(exports.Modal, { callback: this.props.callback, isEscapable: this.props.isEscapable, containerClassName: this.props.containerClassName },
            react_1.default.createElement("div", { className: "confirm-modal" },
                this.props.children,
                react_1.default.createElement(exports.ConfirmModalButtons, { callback: this.props.callback, cancelLabel: this.props.cancelLabel, confirmButtonDestructive: this.props.confirmButtonDestructive, confirming: this.props.confirming ? this.onAsyncConfirmClick : this.onConfirmClick, confirmLabel: this.props.confirmLabel, disableConfirmButton: this.props.disableConfirmButton, disableCancelButton: this.disableCancelButton }))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], ConfirmModal.prototype, "disableCancelButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ConfirmModal.prototype, "onAsyncConfirmClick", void 0);
    ConfirmModal = __decorate([
        mobx_react_1.observer
    ], ConfirmModal);
    return ConfirmModal;
}(react_1.default.Component));
exports.ConfirmModal = ConfirmModal;
var DeleteModal = function (props) {
    return (react_1.default.createElement(ConfirmModal, __assign({}, props, { confirmButtonDestructive: true, confirmLabel: props.confirmLabel || "Delete", cancelLabel: props.cancelLabel })));
};
exports.DeleteModal = DeleteModal;
var StandardModalHeader = function (_a) {
    var title = _a.title, explainer = _a.explainer;
    return (react_1.default.createElement("header", { className: "header" },
        title && react_1.default.createElement("h3", { className: "title" }, title),
        explainer && react_1.default.createElement("p", { className: "explainer" }, explainer)));
};
exports.StandardModalHeader = StandardModalHeader;
exports.default = exports.Modal;
